// فایل: src/i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // زبان پیش‌فرض
    fallbackLng: "en",

    // لیستی از زبان‌های پشتیبانی شده (برای اطمینان بیشتر)
    supportedLngs: ["en", "fa", "ar", "de", "es"], // اسپانیایی را هم اضافه کردم

    debug: false,

    // تنظیمات تشخیص زبان
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },

    // تنظیمات برای i18next-http-backend
    backend: {
      // مسیر فایل‌های ترجمه در پوشه public
      // {{lng}} به صورت خودکار با کد زبان (مثلا en یا fa) جایگزین می‌شود
      loadPath: "/locales/{{lng}}/translation.json",
    },

    // این گزینه بسیار مهم است
    react: {
      // استفاده از Suspense برای مدیریت حالت بارگذاری ترجمه‌ها
      useSuspense: true,
    },
  });

export default i18n;
